export default {"src":"/_next/static/media/comments.e8eeceef.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};